import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $hexagons,
  $hexProperty,
  $showHeatmap,
} from '../../../models/investProModel/index.js';
import { $gradientBucketsHexagons } from '../../../models/gradientModel/index.js';
import { formDynamicBuckets } from '../../../utils/hexagon-utils.js';
import { changeLayerVisibility } from '../../../utils/mapbox-utils.js';

function HexagonsLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const hexagons = useUnit($hexagons);
  const { buckets, colors } = useUnit($gradientBucketsHexagons);
  const showHeatmap = useUnit($showHeatmap);
  const hexProperty = useUnit($hexProperty);

  const createLayer = (update) => {
    const hexagonsData = {
      type: 'FeatureCollection',
      features: hexagons,
    };

    const gradientProp = formDynamicBuckets(
      buckets,
      colors,
      'index',
      hexProperty
    );
    console.log('gradientProp', gradientProp);
    if (update) {
      window.map.getSource('invest_pro_hexagons_source').setData(hexagonsData);
      window.map.setPaintProperty(
        'invest_pro_hexagons_layer',
        'fill-color',
        gradientProp
      );
      window.map.setPaintProperty(
        'invest_pro_hexagons_layer',
        'fill-outline-color',
        gradientProp
      );
    } else {
      if (!window.map.getSource('invest_pro_hexagons_source')) {
        window.map.addSource('invest_pro_hexagons_source', {
          type: 'geojson',
          data: hexagonsData,
        });
      }

      if (!window.map.getLayer('invest_pro_hexagons_layer')) {
        window.map.addLayer({
          id: 'invest_pro_hexagons_layer',
          source: 'invest_pro_hexagons_source',
          type: 'fill',
          paint: {
            'fill-color': gradientProp,
            'fill-opacity': 0.5,
            'fill-outline-color': gradientProp,
          },
        });
      }

      changeLayerVisibility('invest_pro_hexagons_layer', false);
    }
  };

  useEffect(() => {
    if (mapLoaded && hexagons) {
      if (window.map.getLayer('invest_pro_hexagons_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, hexagons, buckets]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('invest_pro_hexagons_layer')) {
      if (showHeatmap) {
        changeLayerVisibility('invest_pro_hexagons_layer', true);
      } else {
        changeLayerVisibility('invest_pro_hexagons_layer', false);
      }
    }
  }, [showHeatmap]);

  return null;
}

export default HexagonsLayer;
